import React, { FunctionComponent, useContext } from 'react'
import { Accordion } from '../../../components/integration-builder/accordion'
import styles from '../integration-builder.module.css'
import cardDetails from './cardDetails.json'
import { Tooltip, Link } from '@paypalcorp/pp-react'
import { CheckoutSimulatorContext } from '../../../components/integration-builder/context/CheckoutSimulatorContext'
import CardGeneratorLayout from './CardGenerator'
import { ExternalLink } from '../../../components/icons'

const Demo: FunctionComponent = () => {
  const { integrationType } = useContext(CheckoutSimulatorContext)

  return (
    <div className={styles.checkout_simulator__accordion_container}>
      <Accordion
        number={3}
        color="secondary"
        heading="Demo using sample credentials"
        defaultCollapsed
        content={
          <>
            <p className={styles.checkout_simulator__fragment_subtitle}>
              Demo checkout as a payer and merchant
            </p>
            <ol>
              <li>
                In the Checkout Preview, select a payment button to demo
                checkout.
              </li>
              <li>
                Log in to the payer's sandbox account using pre-populated
                credentials.
              </li>
              <li>Select a payment method to start the transaction.</li>
              <li>
                Confirm that payment was successful by logging in to the
                merchant's sandbox account using the pre-populated credentials.
              </li>
              <li>
                On a successful transaction, the payment is shown in the
                merchant sandbox account.
              </li>
            </ol>
            {integrationType === 'advanced' ? (
              <p>
                Simulate a successful credit card capture or 3D Secure test
                cards to test different 3DS scenarios and generate a 3DS
                response in the order details.
              </p>
            ) : (
              <p>Simulate successful and unsuccessful credit card capture.</p>
            )}
            <div className={styles.checkout_simulator__subtitle_wrapper}>
              <p className={styles.checkout_simulator__fragment_subtitle}>
                Successful test transaction
              </p>
              <Tooltip
                name="tooltip1"
                description="See a successful card capture in the integration builder using test card numbers."
                windowId="window1"
                imagePosition="bottom-left"
              />
            </div>
            <p>
              Use the following card information
              {integrationType === 'advanced'
                ? ` only when 3DS is unchecked. `
                : '. '}
              <span>
                <Link
                  target="_blank"
                  href="/api/rest/sandbox/card-testing/#link-simulatesuccessfulcardcapture"
                  className={styles.integration_builder__external_link}
                >
                  See more test cases here
                </Link>
                <ExternalLink />
              </span>
              .
            </p>
            <CardGeneratorLayout
              data={cardDetails.positiveTestCard}
              testid="positive-test-card"
            />
            <div className={styles.checkout_simulator__subtitle_wrapper}>
              <p className={styles.checkout_simulator__fragment_subtitle}>
                Negative test transaction
              </p>
              <Tooltip
                name="tooltip1"
                description="See an unsuccessful card capture in the integration builder using test card numbers."
                windowId="window1"
                imagePosition="bottom-left"
              />
            </div>
            <p>
              Use the following card information
              {integrationType === 'advanced'
                ? `only when 3DS is unchecked. `
                : '. '}
              <span>
                <Link
                  target="_blank"
                  href="/api/rest/sandbox/card-testing/#link-simulatecarderrors"
                  className={styles.integration_builder__external_link}
                >
                  See more test cases here
                </Link>
                <ExternalLink />
              </span>
              .
            </p>
            <CardGeneratorLayout
              data={cardDetails.negativeTestCard}
              testid="negative-test-card"
            />
            {integrationType === 'advanced' ? (
              <>
                <div className={styles.checkout_simulator__subtitle_wrapper}>
                  <p className={styles.checkout_simulator__fragment_subtitle}>
                    3D Secure Test Transaction
                  </p>
                  <Tooltip
                    name="tooltip1"
                    description="See an unsuccessful card capture in the integration builder using test card numbers."
                    windowId="window1"
                    imagePosition="bottom-left"
                  />
                </div>
                <p>
                  Use the following card information{' '}
                  {integrationType === 'advanced'
                    ? `only when 3DS is checked. `
                    : '. '}
                  <span>
                    <Link
                      target="_blank"
                      href="/docs/checkout/advanced/customize/3d-secure/test/"
                      className={styles.integration_builder__external_link}
                    >
                      See more test cases here
                    </Link>
                    <ExternalLink />
                  </span>
                  .
                </p>
                <CardGeneratorLayout
                  data={cardDetails['3DSTestCard']}
                  testid="3ds-test-card"
                />
              </>
            ) : null}
          </>
        }
      />
    </div>
  )
}

export default Demo
